import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import BaseComponent from '../../../baseClasses/BaseComponent';
import checkoffDefault from '../../../assets/images/checkoff-default.svg';
import checkoffNA from '../../../assets/images/checkoff-na.svg';
import checkoffChecked from '../../../assets/images/checkoff-checked.gif';
import StepApproval from '../StepApproval';
import CommentPopup from '../CommentPopup';
import TaskCompletionStepComments from '../TaskCompletionStepComments';
import AnalyticsLogger from '../../../helpers/analytics/analyticsLogger';
import CompletionStepUtil from '../../../helpers/CompletionStepUtil/CompletionStepUtil';
import dataModel from '../../../models/DataModel';

import './Checkoff.scss';
import Textarea from '../../Textarea';
//import CompaniesCollection from "../../../dao/collections/CompaniesCollection";

// TODO: collapse <Checkoff> web/mobile components
export class Checkoff extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      checked: false,
      send: false,
      showKeyboard: true,
      sending: false,
    };
    this.handleOnButtonClick = this.handleOnButtonClick.bind(this);
    
    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });
  }

  componentDidMount() {
    if (this.props.completionStep.completed_at && !this.props.completionStep.not_applicable) {
      this.setState({ checked: true, completionStep: this.props.completionStep });
    }
    else {
      this.setState({ checked: false, completionStep: this.props.completionStep });
    }

    // register for speech detection
    dataModel.mobileBridge.addSpeechDetectedObserver(this.handleSpeechDetected);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.completionStep != this.props.completionStep) {
      if (this.props.completionStep.completed_at && !this.props.completionStep.not_applicable) {
        this.setState({ checked: true, completionStep: this.props.completionStep });
      }
      else {
        this.setState({ checked: false, completionStep: this.props.completionStep });
      }
    }
  }

  componentWillUnmount() {
    //unregister for speech detection
    dataModel.mobileBridge.removeSpeechDetectedObserver(this.handleSpeechDetected);
  }

  handleSpeechDetected(speechText) {
    const speechDataLowerWithoutSpaces = speechText.replace(/ /g,'').toLowerCase();
    if (speechDataLowerWithoutSpaces == 'completecheckoff') {
      if (!this.state.checked && this.props.userStepPermissions.has('step_complete')) {
        this.handleCompleteStep(true, true);
      }
    }
    else {
      setTimeout(() => {
        dataModel.showGlobalModal('HANDSFREE_ERROR_MODAL', {
          message: 'Hint: try saying complete checkoff',
        });
      }, 2500);
    }
  }

  handleCompleteStep(isCompleted, nextCS=false) {
    const { task, permissions, userStepPermissions, switchCS, handleHandsFreeTaskComplete } = this.props;
    if (permissions.canCompleteTask && (userStepPermissions.has('step_complete') || userStepPermissions.has('override'))) {
      dataModel.completionCriteriaDAO.completeCompletionCriterion(this.state.completionStep, isCompleted).then(() => {
        const foundCS = dataModel.completionCriteriaDAO.findItem(this.state.completionStep.id);
        if (foundCS) {
          this.setState({ completionStep: Object.assign({}, foundCS) }, () => {
            if (this.props.handleChildCompletionStepUpdate) {
              this.props.handleChildCompletionStepUpdate(foundCS);
            }
            if (nextCS) {
              //handle push to next cs
              setTimeout(() => {
                const { completed, total } = task.completion_criteria_counts;
                if (isCompleted && (total - completed <= 1)) {
                  handleHandsFreeTaskComplete();
                }
                else {
                  switchCS(true);
                }
              }, 2000);
            }
          });
        }
      });
    }
  }

  handleStepToggle = e => {
    const checkedState = e.target.name;
    const { userStepPermissions } = this.props;
    if (!this.state.completionStep.not_applicable) {
      if (checkedState == 'checked' && userStepPermissions.has('override')) {
        this.handleUncheckPopup();
      }
      else if (checkedState == 'unchecked' && userStepPermissions.has('step_complete')) {
        this.setState({ checked: true });
        this.handleCompleteStep(true);
      }
    }
  };

  handleUncheckPopup = () => {
    const stepName = this.state.completionStep.name
      .split(' ')
      .map(
        word => word.substr(0, 1).toUpperCase() + word.substr(1).toLowerCase()
      )
      .join(' ');

    const message = (
      <div>
        <p>Do you want to uncheck the completion step {stepName}?</p>
      </div>
    );

    this.props.dataModel.showGlobalModal('SYSTEM_POPUP', {
      height: 184,
      width: 320,
      message: message,
      cancelButtonText: 'Cancel',
      okButtonText: 'Yes',
      handleOwnerOk: () => {
        this.confirmUncheck();
      },
      handleOwnerCancel: () => {
        this.cancelUncheck();
      },
    });
  };

  confirmUncheck = () => {
    this.props.dataModel.systemPopup = null;
    this.setState({ checked: false });
    this.handleCompleteStep(false);
  };

  cancelUncheck = () => {
    this.props.dataModel.systemPopup = null;
    this.setState({ checked: true });
  };

  handleStepApprove() {
    const { userStepPermissions } = this.props;
    const { completionStep } = this.state;
    if (userStepPermissions.has('is_approver')) {
      this.handleApproved(completionStep);
    }
    else if (userStepPermissions.has('is_reviewer')) {
      this.handleReviewed(completionStep);
    }
  }

  handleStepReject() {
    const { userStepPermissions, task } = this.props;
    if (userStepPermissions.has('accept/reject')) {
      if ((task.has_reviewer && this.state.completionStep.reviewed_at) || !task.has_reviewer){
        this.handleRejectApproval(this.state.completionStep);
      }
      else{
        this.handleRejectReview(this.state.completionStep);
      }
    }
  }

  async handleReviewed(completionStep) {
    // TODO: don't depend on action cable!
    await dataModel.completionCriteriaDAO.reviewCompletionCriterion(this.state.completionStep);

    const foundCS = dataModel.completionCriteriaDAO.findItem(this.state.completionStep.id);
    if (foundCS) {
      if (this.props.handleChildCompletionStepUpdate) {
        this.props.handleChildCompletionStepUpdate(foundCS);
      }
    }
    if (this.state.uploadComment) {
      const newComment = {
        caption: 'Completion Step Approved',
        body: this.state.uploadComment,
        commentable_type: 'CompletionCriterion',
        commentable_id: completionStep.id,
        user_id: this.props.currentUser.id,
      };
      await dataModel.commentsDAO.createComment(newComment, false, null, { recordDescriptor: { comments: {} } });
      this.setState({ uploadComment: '' });
    }
    if (this.props.mobileBridge.isMobile) {
      this.props.history.goBack();
    }
  }

  handleRejectReview(completionStep) {
    this.setState({ rejectionComment: true });
  }

  async handleApproved(completionStep) {
    if (completionStep) {
      completionStep.task_id = this.props.task.id;
      await dataModel.completionCriteriaDAO.approveCompletionCriterion(this.state.completionStep);

      const foundCS = dataModel.completionCriteriaDAO.findItem(this.state.completionStep.id);
      if (foundCS) {
        if (this.props.handleChildCompletionStepUpdate) {
          this.props.handleChildCompletionStepUpdate(foundCS);
        }
      }

      if (this.state.uploadComment) {
        const newComment = {
          caption: 'Completion Step Approved',
          body: this.state.uploadComment,
          commentable_type: 'CompletionCriterion',
          commentable_id: completionStep.id,
          user_id: this.props.currentUser.id,
        };
        await dataModel.commentsDAO.createComment(newComment, false, null, { recordDescriptor: { comments: {} } });
        this.setState({ uploadComment: '' });
      }
      if (this.props.mobileBridge.isMobile) {
        this.props.history.goBack();
      }
    }
  }

  handleRejectApproval(completionStep) {
    this.setState({ rejectionComment: true });
  }

  handleCancelComment() {
    this.setState({
      rejectionComment: false,
    });
  }

  async handleCommentSent(type, commentText) {
    this.setState({ rejectionComment: false });

    const { completionStep } = this.props;

    await dataModel.completionCriteriaDAO.rejectCompletionCriterion(completionStep, commentText);
    this.setState({ commentText: '', sending: false });
    if (this.inputElement) {
      this.inputElement.blur();
    }
    if (this.props.mobileBridge.isMobile) {
      this.props.history.goBack();
    }
  }

  async handleKeyDown(e, type) {
    if (e.keyCode == 27) {
      this.setState({ rejectionComment: false });
    } 
    else if (e.keyCode == 13 || e.keyCode == 40) {
      // e.preventDefault();
      this.setState({ rejectionComment: true });
      this.state.showKeyboard=false;
      this.handleSetInputElement(e.target,e);
      // const { completionStep } = this.props;
      // if (this.state.commentText) {
      //   await dataModel.completionCriteriaDAO.rejectCompletionCriterion(completionStep, this.state.commentText)

      //   this.setState({ commentText: "" });
      //   if (this.props.mobileBridge.isMobile) {
      //     this.props.history.goBack()
      //   }
      // } 
    }
  }

  handleOnButtonClick(){
    this.state.send=true;
    this.state.sending=true;
    if(this.state.commentText){
      this.handleCommentSent('reject', this.state.commentText);
    }
  }

  handleCommentChange(e) {
    if(e.target.value.trim()!=''){
      this.setState({ commentText: e.target.value });
    }
    else{
      this.setState({ commentText: '' });
    }
  }
  
  handleSetInputElement(element,e) {
    if (element && e==null && this.state.showKeyboard) {
      this.inputElement = element;
      this.inputElement.focus(); 
    }  
    else if(e && element && !this.state.showKeyboard){
      this.inputElement = element;
      this.inputElement.blur();   
    }
  }
  handleDetermineRejected(task){
    const stepsRejected = task.completion_criteria
    ? task.completion_criteria.filter(cc => {
      if (cc) {
        return (
          cc.rejected_at &&
          !cc.approved_at &&
          !cc.reviewed_at &&
          !cc.completed_at
        );
      }
      else {
        return false;
      }
    }
    )
    : [];
    return stepsRejected.length > 0;
  }

  handleNotApplicableButton() {
    const { completionStep } = this.state;

    //check if a response exists
    if (completionStep.response) {
      //display popup
      dataModel.showGlobalModal('SYSTEM_POPUP', {
        height: 184,
        width: 320,
        message: this.textMap.markPartialFormAsNA,
        cancelButtonText: 'Cancel',
        okButtonText: 'Yes',
        handleOwnerOk: () => {
          this.handleNotApplicableSend();
        },
        handleOwnerCancel: () => {},
      });
    }
    else {
      this.handleNotApplicableSend();
    }

  }
  
  handleNotApplicableSend() {
    const { completionStep } = this.state;
    completionStep.not_applicable = true;
    completionStep.completed_at = new Date().toJSON();
    CompletionStepUtil.handleCSNotApplicableButton(completionStep, this.analyticsLogger).catch(error => {
      completionStep.not_applicable = null;
      completionStep.completed_at = null;
      this.setState({ completionStep });
    });
    this.setState({ completionStep });
  }

  handleUndoNotApplicable() {
    const { completionStep } = this.state;
    completionStep.not_applicable = null;
    completionStep.completed_at = null;
    CompletionStepUtil.handleCSUndoNotApplicableButton(completionStep, this.analyticsLogger).catch(error => {
      completionStep.not_applicable = null;
      completionStep.completed_at = null;
      this.setState({ completionStep });
    });
    this.setState({ completionStep, checked: false });
  }
  
  createButtonList() {
    const { task, completionStep, userStepPermissions } = this.props;
    
    let buttons = [];

    if (task.status != 'completed' &&
      !completionStep.not_applicable &&
      userStepPermissions.has('step_complete')
    ) {
      buttons.push(
        <div
          className="mobile-button mobile-na-button"
          key="no-image-button"
          onClick={this.handleNotApplicableButton}
          data-qa="not-applicable-button"
        />
      );
    }
    else if (
      completionStep.not_applicable && (userStepPermissions.has('unmarkNA') ||
      ((userStepPermissions.has('step_complete') || userStepPermissions.has('step_update')) &&  
      !completionStep.reviewed_at && !completionStep.approved_at &&
      (completionStep.status != 'completed'))
    )) {
      buttons.push(
        <div
          className="mobile-button mobile-undo-na-button"
          key="undo-na-button"
          onClick={this.handleUndoNotApplicable}
          data-qa="not-applicable-button"
        />
      );
    }

    if (this.props.mobileBridge.isMobile && task.status != 'completed') {
      buttons.push(
        <div
          key="comment-button"
          className="mobile-button mobile-comments-button"
          onClick={this.props.handleCommentsButton}
        >
          {completionStep.comments.length > 0 && <div className="indicator-dot" />}
        </div>
      );
    }

    return buttons;
  }
  
  render() {
    const { 
      editing, 
      task, 
      userStepPermissions, 
    } = this.props;
    let toggleImage;
    let imgClassName = 'checkoff';

    const { completionStep } = this.state;
    if (!completionStep) {
      return null;
    }
    
    if (completionStep.not_applicable) {
      imgClassName += '-checked';
      if (userStepPermissions.has('override')) {
        imgClassName += ' checkoff-checked--clickable';
      }
      toggleImage = (
        <img
          name="checked"
          src={checkoffNA}
          onClick={this.handleStepToggle}
          className={imgClassName}
          alt="Completion step NA"
        />
      );
    } else if (this.state.checked) {
      imgClassName += '-checked';
      if (userStepPermissions.has('override')) {
        imgClassName += ' checkoff-checked--clickable';
      }
      toggleImage = (
        <img
          name="checked"
          src={checkoffChecked}
          onClick={this.handleStepToggle}
          className={imgClassName}
          alt="Completion step checked"
        />
      );
    } else if (!editing) {
      imgClassName += '-unchecked';
      if (userStepPermissions.has('step_complete')) {
        imgClassName += ' checkoff-unchecked--clickable';
      }
      toggleImage = (
        <img
          name="unchecked"
          src={checkoffDefault}
          onClick={this.handleStepToggle}
          className={imgClassName}
          alt="Completion step unchecked"
        />
      );
    }

    let background, commentDisplay, reviewApproveButtons, comments;

    let buttons = this.createButtonList();
    
    let sendButton = (
      <div className="send-button disabled">
        <div className="send-text disabled">SEND</div>
      </div>
      );
  
    if (this.state.commentText && this.state.commentText!='') {
      sendButton = (
        <div className={!this.state.sending?'send-button ':'send-button disabled'} onClick={!this.state.sending?this.handleOnButtonClick:null}>
          <div className="send-text">SEND</div>
        </div>
      );
    }
    if (!editing) {
      if (this.state.rejectionComment) {
        if (this.props.mobileBridge.isMobile) {
          background = <div className="background-disable" onClick={this.handleCancelComment}/>;
          commentDisplay = (
            <div className="comment-input">
              <Textarea
                rows={3}
                ref={element => {this.handleSetInputElement(element,null);}}
                className="text-input"
                placeholder="You must leave a comment to reject a Completion Step."
                onChange={this.handleCommentChange}
                value={this.state.commentText}
                onKeyDown={e => this.handleKeyDown(e, 'reject')}
                dataId={completionStep.id}
                style={{ resize: 'none' }}
                id={'comment-input'}
              />
              {sendButton}
            </div>
          );
        } else {
          const element = document.getElementById(
            'task-completion-step-comments-' + completionStep.id
          );
          const rect = element.getBoundingClientRect();
          commentDisplay = (
            <CommentPopup
              task={task}
              completionStep={completionStep}
              height={element.clientHeight}
              width={element.clientWidth}
              left={rect.left}
              top={rect.top - 20}
              type={'REJECTED'}
              commentSent={commentText =>
                this.handleCommentSent('reject', commentText)
              }
              placeholder={
                'You must leave a comment to reject a Completion Step.'
              }
              cancelComment={this.handleCancelComment}
            />
          );
        }
      }
  
      if (!this.state.rejectionComment && !completionStep.rejected_at && !editing &&
        userStepPermissions.has('accept/reject')){
        reviewApproveButtons = (
          <div className="approve-reject-buttons">
          <StepApproval key={(task.has_reviewer && (userStepPermissions.has('is_reviewer') || this.props.currentUser.super_admin) &&
            !completionStep.reviewed_at ? '_review' : '_approve') + completionStep.id} userStepPermissions={userStepPermissions}
              handleStepReject={this.handleStepReject}
              handleStepApprove={this.handleStepApprove}
            />
          </div>
        );
      }
  
      if (!this.props.mobileBridge.isMobile) {
        comments = (
          <TaskCompletionStepComments
            id={'task-completion-step-comments-' + this.state.completionStep.id}
            task={this.props.task}
            completionStep={this.state.completionStep}
          />
        );
      }
    }
    return (
      <div className="task-completion-step checkoff">
        {background}
        {!this.props.mobileBridge.isMobile &&
          this.state.completionStep.instructions && (
            <div className="checkoff-instructions">
              <div className="instruction-label">Instructions</div>
              <div className="instruction-text">
                {this.state.completionStep.instructions}
              </div>
            </div>
          )}
        {toggleImage}
        {reviewApproveButtons}
        {this.props.mobileBridge.isMobile && (
          <div
            className={`mobile-button-list ${
              userStepPermissions.has('accept/reject')
                ? 'review-approve'
                : ''
            }`}
          >
            {buttons}
          </div>
        )}
        {comments}
        {commentDisplay}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: dataModel,
    mobileBridge: dataModel.mobileBridge,
    permissions: state.new_users.permissions,
    currentUser: state.new_users.currentUser,
  };
};

export default connect(mapStateToProps, null)(withRouter(Checkoff));



// WEBPACK FOOTER //
// ./src/components/TaskCompletionStepsMobile/Checkoff/index.js